import message from 'ant-design-vue/es/message';
import axios from 'axios';
import store from '../store';
import { getToken } from 'minerva-ui-sdk';

const errorParser = (response) => {
  if (response.status < 300) {
    return response;
  } else if (response.status === 401) {
    const token = getToken();
    message.error('身份认证已失效，即将返回登录');
    if (token) {
      store.dispatch('Logout').then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
    }
    return Promise.reject(new Error('Unauthorized'));
  } else if (response.data && response.data.errorMessage) {
    message.error(response.data.errorMessage);
    const error = new Error(response.data.errorMessage);
    return Promise.reject(error);
  }
  return Promise.reject(new Error('unknown network error'));
};

export const createInstance = (baseUrl, authenticated) => {
  const timeout = 5000000;
  let headers = {};
  if (authenticated) {
    headers = { 'x-auth-key': 'Bearer ' + getToken() };
  }
  const instance = axios.create({
    baseURL: baseUrl,
    timeout,
    headers,
    validateStatus: () => true
  });
  instance.interceptors.response.use(errorParser);
  return instance;
};

export const createAuthInstance = (baseUrl) => createInstance(baseUrl, true);

export const createWorkspaceInstance = (baseUrl) => {
  const instance = createAuthInstance(baseUrl);
  instance.interceptors.request.use(request => {
    request.params = request.params || {};
    request.params.workspaceId = store.getters.workspace.id;
    return request;
  });
  return instance;
};
